import { css } from 'glamor'
import * as React from 'react'
import * as PropTypes from 'prop-types'
import { defineMessages, FormattedMessage } from 'react-intl'

import { Button } from '../button'

import Icon from './icon.svg'

const messages = defineMessages({
  searchLabel: {
    id: 'ui-kit.search-field.search-label',
    defaultMessage: 'Search',
  },
})

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
  },
  label: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
  },
  input: {
    border: '0',
    flexGrow: 1,
    marginLeft: '16px',
    marginRight: '16px',
    outline: '0',
    height: '40px',
    appearance: 'none',
    WebkitAppearance: 'none',
    MozAppearance: 'none',
  },
}

interface ISearchFieldProps {
  action?: string
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  onSubmit?: (event: React.FormEvent<HTMLFormElement>) => void
  placeholder?: string
  processing?: boolean
  queryParameterName?: string
  value: string
}

export function SearchField({
  action,
  onChange,
  onSubmit,
  placeholder,
  processing,
  queryParameterName,
  value,
}: ISearchFieldProps) {
  /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
  return (
    <form action={action} method="get" onSubmit={onSubmit} {...css(styles.container)}>
      <label htmlFor="search" {...css(styles.label)}>
        <Icon color="#B6C6D6" />
        <input
          id="search"
          name={queryParameterName}
          onChange={onChange}
          placeholder={placeholder}
          {...css(styles.input)}
          type="search"
          value={value}
        />
      </label>
      <Button flush processing={processing} size="small">
        <FormattedMessage {...messages.searchLabel} />
      </Button>
    </form>
  )
}

SearchField.defaultProps = {
  queryParameterName: 'q',
}

SearchField.propTypes = {
  action: PropTypes.string,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  placeholder: PropTypes.string,
  processing: PropTypes.bool,
  queryParameterName: PropTypes.string,
  value: PropTypes.string,
}
